import { Icon } from "../../components/Icon";
import { COMPANY, WHATSAPP } from "../../config/company";
import { CompanyLayout, InfoSection, SafetyNote } from "./CompanyLayout";

const FIRST_STEPS = [
  {
    title: "Say hello",
    body: "Open the chat and send any message. There’s no app to install and nothing to download.",
  },
  {
    title: "Set up in one form",
    body: "A secure form opens inside WhatsApp: your name, your email, whether people may ask you to pay bills (Ejor), and a transaction PIN. It takes about a minute.",
  },
  {
    title: "Add your card",
    body: "Hethera sends you a Paystack link to save your debit card. A small check charge confirms it and is refunded. We never see your full card number.",
  },
  {
    title: "Ask for what you need",
    body: "“Buy ₦1,000 MTN airtime”, “renew my GOtv”, “₦5,000 light for my meter”. Check the details, confirm with your PIN, and get your receipt in the chat.",
  },
];

const KEYWORDS: [string, string][] = [
  ["EJOR", "Ask someone you know to pay a bill"],
  ["DASH", "Send airtime or electricity as a gift"],
  ["SCHEDULE", "See and manage scheduled payments"],
  ["REPORT", "Get a private link to your spending"],
  ["CANCEL EJ-…", "Cancel an Ejor or a gift (CANCEL DS-…) by its code"],
];

export function WhatsAppPage() {
  return (
    <CompanyLayout
      path="/whatsapp"
      eyebrow="WhatsApp"
      title="Start in the chat you already use."
      intro="Hethera lives on WhatsApp. Open the chat, say hello, and you can pay your first bill in a few minutes."
      actions={
        <a className="btn btn-accent btn-lg" href={WHATSAPP.href}>
          <Icon name="chat" />
          Open Hethera in WhatsApp
        </a>
      }
      aside={
        <a className="qr-big" href={WHATSAPP.href}>
          <img
            src={WHATSAPP.qr}
            alt="QR code that opens Hethera on WhatsApp"
            width={220}
            height={220}
          />
          <span>
            <strong>On a computer?</strong>
            Point your phone’s camera at the code.
          </span>
        </a>
      }
    >
      <InfoSection
        title="Your first five minutes"
        lede="What happens after you send your first message."
      >
        <ol className="principles">
          {FIRST_STEPS.map((s) => (
            <li key={s.title}>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </li>
          ))}
        </ol>
      </InfoSection>

      <InfoSection
        title="Make sure it’s really us"
        lede="Scammers copy names and logos. These are the details that can’t be copied."
      >
        <dl className="company__facts">
          <div>
            <dt>WhatsApp Business number</dt>
            <dd>
              {WHATSAPP.digits ? (
                <a href={WHATSAPP.href}>{WHATSAPP.display}</a>
              ) : (
                WHATSAPP.display
              )}
            </dd>
          </div>
          <div>
            <dt>Name in the chat</dt>
            <dd>Hethera AI, shown as a business account</dd>
          </div>
          <div>
            <dt>Card payments</dt>
            <dd>
              Only through Paystack pages that Hethera sends you in the chat
            </dd>
          </div>
          <div>
            <dt>Your PIN</dt>
            <dd>
              Only in the secure form inside WhatsApp, never typed as a chat
              message
            </dd>
          </div>
          <div>
            <dt>Operated by</dt>
            <dd>
              {COMPANY.legalName}, RC {COMPANY.rcNumber}
            </dd>
          </div>
        </dl>
        <SafetyNote />
      </InfoSection>

      <InfoSection
        title="Shortcuts"
        lede="Write in your own words, or send one of these for an instant answer."
      >
        <ul className="keyword-list">
          {KEYWORDS.map(([word, body]) => (
            <li key={word}>
              <span className="keyword">{word}</span>
              {body}
            </li>
          ))}
        </ul>
        <p className="info-more">
          The assistant remembers your conversation for a few hours, so you can
          pick up where you left off. Questions it can’t answer go to{" "}
          <a href="/support">email support</a>.
        </p>
      </InfoSection>
    </CompanyLayout>
  );
}
